import Loader from '@/components/Loader';
import { useEditForm, UseEditFormProps } from '@/hooks/refinedev/useEditForm';
import {ReactNode} from 'react';
import {FormProvider} from 'react-hook-form';

const EditForm = (
  props: UseEditFormProps & {children?: ReactNode} & Partial<React.ComponentProps<'form'>>,
) => {
  const {children, formProps, transformBeforeSave, submitDirtyFieldsOnly, ...nativeFormProps} =
    props;
  const useFormResults = useEditForm({formProps, transformBeforeSave, submitDirtyFieldsOnly});
  const {
    handleSubmit,
    refineCore: {onFinish, query},
  } = useFormResults;

  // Nếu uncomment dòng dưới, <form> sẽ không được setValue sau khi query finish
  // Nguyên nhân do <form> vấn đề gì đó giữa useForm và setValue
  // if (query?.isLoading) return <Loader />;

  return (
    <FormProvider {...useFormResults}>
      {query?.isLoading && <Loader />}
      <form onSubmit={handleSubmit(onFinish)} hidden={query?.isLoading} {...nativeFormProps}>
        {children}
      </form>
    </FormProvider>
  );
};

export default EditForm;
